import { useMutation } from "react-query";
import updateSpvKyc from "../services/updateSpvKyc";

const useUpdateSpvKyc = () => {
  return useMutation(["update-spv-kyc"], updateSpvKyc);
};

export default useUpdateSpvKyc;
